import { Box, Button, Grid, GridColumn } from "@modernatx-internal/ui-kit-react";
import React from "react";

import { NoticeFilterProps } from "@/types/Block";

import { BlockColumns } from "../BlockColumns";
import { BlockText } from "../BlockText";

const ALL_VALUE = "all";

export const NoticeFilter: React.FC<NoticeFilterProps> = ({ items, options }) => {
  const [selected, selectedSet] = React.useState(options[0]?.value || ALL_VALUE);

  const visibleColumns = items
    .filter((item) => selected === ALL_VALUE || item.product === selected)
    .map((item) => item.column);

  return (
    <>
      <Grid>
        <GridColumn>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
            {options.map((option) => (
              <Button
                key={option.value}
                size="small"
                variant={selected === option.value ? "primary" : "secondary"}
                onClick={() => selectedSet(option.value)}
              >
                <Box sx={{ alignItems: "center", display: "flex", gap: 2 }}>
                  {option.icon && (
                    <Box as="img" alt="" src={option.icon} sx={{ height: 5, width: "auto" }} />
                  )}
                  <BlockText as="fragment" text={option.label} />
                </Box>
              </Button>
            ))}
          </Box>
        </GridColumn>
      </Grid>
      <BlockColumns columns={visibleColumns} />
    </>
  );
};
